import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52125f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex-col relative z-0" }
const _hoisted_2 = { class: "md:w-3/4" }
const _hoisted_3 = { class: "mb-8 font-space text-medium font-bold text-xl text-justify" }
const _hoisted_4 = { class: "map-wrapper" }
const _hoisted_5 = { class: "text-center mt-8" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-xxs mt-8 w-1/2 pr-24 text-gray-400" }
const _hoisted_8 = {
  href: "https://www.researchgate.net/figure/Map-of-the-23-world-regions-AFR-Sub-Saharan-Africa-ANZ-Australia-New-Zealand-BEN_fig7_265729759",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = {
  key: 0,
  class: "w-full h-full fixed z-10 opacity-95 bg-pxblue justify-center items-center top-0 flex flex-col answer-wrapper p-2"
}
const _hoisted_11 = { class: "text-justify" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-full p-8",
  src: "img/map_china.svg"
}, null, -1))
const _hoisted_13 = { class: "text-justify" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-full p-8",
  src: "img/map_china.svg"
}, null, -1))
const _hoisted_15 = { class: "text-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": "",
      class: "min-h-full"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("h3", _hoisted_3, null, 512), [
            [_directive_t, 'map.title']
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("object", {
            id: "map",
            ref: "map",
            class: "w-full sm:h-full",
            data: "img/map.svg",
            type: "image/svg+xml",
            onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initMap()))
          }, null, 544)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "px-8 orange-button min-w-12",
            disabled: !_ctx.lastSelected,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit()))
          }, _toDisplayString(_ctx.lastSelected ? _ctx.$t('buttons.submit') : _ctx.$t('map.button-instructions')), 9, _hoisted_6)
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('map.map-notice')) + " ", 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('map.map-notice-link')), 1),
          _hoisted_9
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    (_ctx.ok !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.ok === true)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                title: _ctx.$t('That\'s correct'),
                class: "w-card max-w-full"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("p", _hoisted_11, null, 512), [
                    [_directive_t, 'map.card-text']
                  ]),
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.ok === false)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 1,
                title: _ctx.$t('That\'s incorrect'),
                class: "w-card max-w-full"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("p", _hoisted_13, null, 512), [
                    [_directive_t, 'map.card-text']
                  ]),
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: "img/arrow.icon.svg",
              alt: "next page",
              class: "next-arrow2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}